module.exports = __webpack_public_path__ + "img/软件应用.dbb60532.gif";